export const RFC = {
    Codigo: 0,
    Mensaje: null,
    RFC_10_D: "",
    RFC_COMPLETO: "",
    homoclave: ""
}